import React from "react";

import instagramIcon from "../images/instagram.png";
import facebookIcon from "../images/social-media.png";
// import youtubeIcon from "../images/youtube.png";
// import businessIcon from "../images/business.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container">
        <div className="footerLink" style={{}}>
          <a href="#about" rel="noopener noreferrer">
            About
          </a>
          <a href="#services" rel="noopener noreferrer">
            Coaching Programs
          </a>
          <a href="#contact" rel="noopener noreferrer">
            Contact
          </a>
          <a
            href="mailto:info@anchorpoints.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            Email
          </a>
        </div>

        <div className="footerIcon" style={{}}>
          <a
            href=" https://www.instagram.com/anchorpoint.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={instagramIcon}
              alt="Instagram"
              style={{ width: "24px", height: "24px" }}
            />
          </a>
          <a
            href="https://www.facebook.com/share/1HZyqzfdHF/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={facebookIcon}
              alt="Facebook"
              style={{ width: "24px", height: "24px" }}
            />
          </a>
          {/* <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={youtubeIcon}
              alt="YouTube"
              style={{ width: "24px", height: "24px" }}
            />
          </a>
          <a href="#" target="_blank" rel="noopener noreferrer">
            <img
              src={businessIcon}
              alt="Business"
              style={{ width: "24px", height: "24px" }}
            />
          </a> */}
        </div>
      </div>
      <div className="container mt-2 pt-2 footer_bottom" style={{borderTop: "1px solid #c3913d"}}>
        <p className="w-100">
          © {currentYear} Anchor Point. All rights reserved.
        </p>
        <p className="w-100">
          Design and development by{" "}
          <a
            href="https://www.neoniche.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#c3913d", textDecoration: "none" }}
          >
            NeoNiche.
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
